"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Positions_1 = __importDefault(require("../../common/enums/Positions"));
var PositionUtils_1 = __importDefault(require("../../utils/PositionUtils"));
var TOOLTIP_MAX_WIDTH = 480;
var BREATHING_ROOM = 8;
var repositionTooltip = function (positionUtils) {
    if (positionUtils.isOutsideWindow()) {
        var topDistance = positionUtils.getTriggerPosition().top;
        var bottomDistance = document.documentElement.clientHeight - positionUtils.getTriggerPosition().bottom;
        var leftDistance = positionUtils.getTriggerPosition().left;
        var rightDistance = document.documentElement.clientWidth - positionUtils.getTriggerPosition().right;
        if (positionUtils.isVerticalPosition() && positionUtils.isOutsideVertical() && topDistance !== bottomDistance) {
            return topDistance > bottomDistance ? Positions_1.default.TOP : Positions_1.default.BOTTOM;
        }
        else if (!positionUtils.isVerticalPosition() && positionUtils.isOutsideHorizontal() && leftDistance !== rightDistance) {
            return leftDistance > rightDistance ? Positions_1.default.LEFT : Positions_1.default.RIGHT;
        }
    }
    return positionUtils.getPosition();
};
var getClassNames = function (position, classes) {
    var _a;
    return classnames_1.default('fds-tooltip', (_a = {},
        _a["fds-position-" + position] = position,
        _a['fds-position-centered'] = position,
        _a), classes);
};
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.trigger = react_1.default.createRef();
        _this.content = react_1.default.createRef();
        _this.wrapper = react_1.default.createRef();
        _this.state = {
            position: _this.props.position,
            wrapperStyle: {}
        };
        return _this;
    }
    Tooltip.prototype.setTooltipPosition = function (onMouseEnter) {
        var _this = this;
        var positionUtils = new PositionUtils_1.default(this.trigger.current, this.content.current, this.props.position, BREATHING_ROOM, true, TOOLTIP_MAX_WIDTH);
        this.setState(function (prevState) {
            var origSize = {
                width: (prevState.origSize && prevState.origSize.width) || _this.content.current.getBoundingClientRect().width,
                height: (prevState.origSize && prevState.origSize.height) || _this.content.current.getBoundingClientRect().height
            };
            var position = repositionTooltip(positionUtils);
            var newWrapperStyle = positionUtils.getContentStyle();
            var shouldReposition = prevState.wrapperStyle && newWrapperStyle && prevState.wrapperStyle.width !== newWrapperStyle.width;
            return {
                origSize: origSize,
                position: position,
                wrapperStyle: shouldReposition ? newWrapperStyle : prevState.wrapperStyle
            };
        }, onMouseEnter && onMouseEnter());
    };
    Tooltip.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, classes = _a.classes, onMouseEnter = _a.onMouseEnter, text = _a.text, otherProps = __rest(_a, ["children", "classes", "onMouseEnter", "text"]);
        var _b = this.state, position = _b.position, wrapperStyle = _b.wrapperStyle;
        delete otherProps.position;
        return (react_1.default.createElement("div", __assign({ ref: this.trigger, className: getClassNames(position, classes), onMouseEnter: function () { return _this.setTooltipPosition(onMouseEnter); } }, otherProps),
            children,
            react_1.default.createElement("span", { ref: this.wrapper, className: "fds-tooltip-wrapper fds-position-content", style: wrapperStyle },
                react_1.default.createElement("span", { ref: this.content, className: "fds-tooltip-content" }, text))));
    };
    Tooltip.defaultProps = {
        position: Positions_1.default.BOTTOM
    };
    return Tooltip;
}(react_1.default.Component));
exports.default = Tooltip;
